import * as React from 'react';
import { Category, CategoryType } from 'owa-categories';
import { logUsage } from 'owa-analytics';
import { observer } from 'mobx-react';

export interface CategoryWellProps {
    categoryWellContainerClass: string;
    categoryContainerClass?: string;
    categories: string[];
    onCategoryClicked?: (
        ev: React.MouseEvent<unknown>,
        category: string,
        actionSource: string
    ) => void;
    categoryList?: CategoryType[];
}

@observer
export default class CategoryWell extends React.Component<CategoryWellProps, {}> {
    componentDidMount() {
        this.logNumberOfCategories(this.props.categories);
    }

    componentWillReceiveProps(nextProps: CategoryWellProps) {
        /**
         * Log the number of categories only if they have changed
         */
        if (this.props.categories.length != nextProps.categories.length) {
            this.logNumberOfCategories(nextProps.categories);
        }
    }

    logNumberOfCategories(categories: string[]) {
        logUsage('Category_Well_TotalCategories', [categories.length]);
    }

    render() {
        return (
            <div className={this.props.categoryWellContainerClass}>
                {this.renderCategories(this.props.categories, this.props.categoryContainerClass)}
            </div>
        );
    }

    private renderCategories(categories: string[], categoryContainerClass: string) {
        const categoryElements: JSX.Element[] = [];
        for (let i = categories.length - 1; i >= 0; i--) {
            const categoryName = categories[i];
            categoryElements.push(
                <Category
                    key={categoryName}
                    actionSource={'CategoryWell'}
                    category={categoryName}
                    containerClassName={categoryContainerClass}
                    isLastInWell={i == 0}
                    onCategoryClicked={this.props.onCategoryClicked}
                    categoryList={this.props.categoryList}
                />
            );
        }

        return categoryElements;
    }
}
